import { Component, Inject } from '@angular/core';
import { FormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { WorkorderApiService } from 'src/app/services/api/workorder-api.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-evaluate-modal',
  templateUrl: './evaluate-modal.component.html',
  styleUrls: ['./evaluate-modal.component.scss'],
})
export class EvaluateModalComponent {
  formGroup: UntypedFormGroup;
  constructor(
    private message: MessageService,
    private api: WorkorderApiService,
    private dialogRef: MatDialogRef<EvaluateModalComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.formGroup = this.fb.group({
      star_level: [0, [Validators.required]],
      service_star_level: [0, [Validators.required]],
      product_star_level: [0, [Validators.required]],
      // overall_eval: ['', [Validators.required]],
      is_resolved: [true, [Validators.required]],
      feedback: ['', []],
      service_eval: ['', [Validators.required]],
      product_eval: ['', [Validators.required]],
    });
    this.organizeData();
  }

  close(r: any = null) {
    this.dialogRef.close(r);
  }

  select(status: boolean) {
    this.formGroup.patchValue({
      is_resolved: status,
    });
  }

  onRateChangeService(event: any) {
    this.formGroup.patchValue({
      service_star_level: event.rate,
      service_eval: event.details.toString(),
    });
  }

  onRateChangeProduct(event: any) {
    this.formGroup.patchValue({
      product_star_level: event.rate,
      product_eval: event.details.toString(),
    });
  }

  loading = false;
  async onOk() {
    if (
      !this.formGroup.value.product_star_level ||
      !this.formGroup.value.product_eval
    ) {
      this.message.warn('请选择产品体验', { position: 'top' });
      return;
    }
    if (
      !this.formGroup.value.service_star_level ||
      !this.formGroup.value.service_eval
    ) {
      this.message.warn('请选择客服服务', { position: 'top' });
      return;
    }
    const star_level =
      (this.formGroup.value.service_star_level +
        this.formGroup.value.product_star_level) /
      2;
    try {
      this.loading = true;
      const r = await this.api.postWorkorderFeedback(
        this.data.work_order_id,
        this.value.user_id,
        this.value.handler_id,
        this.value.bus_id,
        star_level.toString(),
        this.formGroup.value.is_resolved,
        this.formGroup.value.feedback,
        this.formGroup.value.service_eval,
        this.formGroup.value.product_eval,
        this.formGroup.value.service_star_level.toString(),
        this.formGroup.value.product_star_level.toString()
      );
      if (r.status === 0) {
        this.close(true);
      } else {
        this.message.warn('未知错误');
      }
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }

  value: any;
  organizeData() {
    this.value = {
      user_id: this.data.workorder.user_id,
      handler_id: this.data.created_by,
      bus_id: this.data.workorder.bus_seat.bus_id,
    };
  }

  product_list = {
    1: ['功能严重故障', '完全无法使用', '数据错误'],
    2: ['经常报错', '操作极繁琐', '加载非常慢'],
    3: ['偶有卡顿', '部分功能难用', '勉强可用'],
    4: ['运行流畅', '界面直观', '功能实用'],
    5: ['体验极佳', '运行丝滑', '功能强大', '设计精美'],
  };
  service_list = {
    1: ['态度恶劣', '拒绝沟通', '不解决问题'],
    2: ['回复极慢', '答非所问', '业务不熟练'],
    3: ['回复较慢', '态度平淡', '勉强解决'],
    4: ['响应及时', '解答清晰', '态度友好'],
    5: ['专业高效', '秒回信息', '服务热情', '完美解决'],
  };
}
